export const peripheryAddresses = {
  adaptiveCurveIRMFactory: "0x967803d884DF006A7150Bc3fCD416b813fbCbF4A",
  capRiskStewardFactory: "0x3765c742E738cf401e2141D2FEfA8D1CB0d8fdFD",
  edgeFactory: "0xdF07AC6F90312E501B67B4ff29c8782DB959748E",
  edgeFactoryPerspective: "0xcFcb87Eb3E796B35C9678feD440B2a857af94ed9",
  escrowedCollateralPerspective: "0xf3e1Dd13C448A7E1a6e19ba8A7f29f45C1E93AaB",
  eulerEarnFactoryPerspective: "0x0490013112B6beb8545E6776cc67D8A40023690a",
  eulerEarnGovernedPerspective: "0xe4A695d715732db3d694E30EC57b1acc8cC4368b",
  eulerEarnPublicAllocator: "0x65A66F24a25E8CF651C9e31D296623298C80F742",
  eulerUngoverned0xPerspective: "0x47B7b629409117e5C99D9F161E47Ff304cF520f6",
  eulerUngovernedNzxPerspective: "0x36951cC4AC6f8Ec5E01787a95689b2C3466E6538",
  evkFactoryPerspective: "0x9266C8c71fDA44EcC7Df2A14E12C6E1aA9C96Ca7",
  externalVaultRegistry: "0x62e9d884cbE9a6B59a6014c9751C06551B83943E",
  feeCollector: "0x0000000000000000000000000000000000000000",
  feeFlowController: "0x9527062A472666410DC7193A966709105dF2f147",
  feeFlowControllerUtil: "0x260fA2473c23F362344d733B56e64864a9Efe92c",
  fixedCyclicalBinaryIRMFactory: "0x6F1228b0A111173Dd3A295D32b5157fA3410de96",
  governedPerspective: "0x8707B105567661E7c6B41cDd1b3EC7D784e5FA50",
  governorAccessControlEmergencyFactory:
    "0x21BFce0c4E9411cd6c7F6D28edC9244f89bFEe63",
  irmRegistry: "0xB402699Ab5B255b68b4A4cdD3E171a67A9124FC7",
  kinkIRMFactory: "0x05Cccb5d0f1e1D568804453B82453a719Dc53758",
  kinkyIRMFactory: "0x3512f50B3f0cA8725CcCBb6DDcc7307Ed2c17feb",
  oracleAdapterRegistry: "0xCC5EDE0Ea39f2F8c80C461B7e954FB4256773AFa",
  oracleRouterFactory: "0xdDA3cBC18e90606A83FBae6F798991af06dFA902",
  swapVerifier: "0x65bF068c88e0f006f76b871396B4DB1150dd9EAD",
  swapper: "0xB6D7194fD09F27890279caB08d565A6424fb525D",
  termsOfUseSigner: "0x157758cB5dD1Fe71b89622559BbAb0dd8Def8A69",
} as const
